import request from '@/utils/request'

export function getAllServices (name, pageSize, pageNo) {
	return request({
		url: '/api/merchant/business/services-all-openeds?name=' + name + '&pageSize=' + pageSize + '&pageNo=' + pageNo,
		method: 'get'
	})
}

export function postAuthentication (unitName, creditCode, url) {
	return request({
		url: '/api/merchant/business/real-name-authentication',
		method: 'post',
		data: {
			unitName,
			creditCode,
			url
		}
	})
}

export function updateBusinessAddress (address) {
	return request({
		url: '/api/merchant/business/update-business-address',
		method: 'post',
		data: {
			address
		}
	})
}

export function updateBusinessPwd (newPwd, pwd) {
	return request({
		url: '/api/merchant/business/update-business-pwd',
		method: 'post',
		data: {
			newPwd,
			pwd
		}
	})
}

export function updateBusinessMobile (mobile, validateCodeSms) {
	return request({
		url: '/api/merchant/business/update-business-mobile',
		method: 'post',
		data: {
			mobile,
			validateCodeSms
		}
	})
}

export function updateBusinessEmail (query) {
	return request({
		url: '/api/merchant/business/update-business-email',
		method: 'post',
		data: query
	})
}

export function setBusinessPwd (query) {
	return request({
		url: '/api/merchant/business/set-business-pwd',
		method: 'post',
		data: query
	})
}

export function getSubList (keyword, pageSize, page) {
	return request({
		url: '/api/merchant/business/sub/list?keyword=' + keyword + '&pageSize=' + pageSize + '&page=' + page,
		method: 'get'
	})
}

export function addSubBusiness (query) {
	return request({
		url: '/api/merchant/business/sub/add',
		method: 'post',
		data: query
	})
}

export function resetSubPw (password, subId) {
	return request({
		url: '/api/merchant/business/sub/resetPw',
		method: 'post',
		data: {
			password,
			subId
		}
	})
}

export function rechargeSubAcc (amount, subId) {
	return request({
		url: '/api/merchant/business/sub/recharge',
		method: 'post',
		data: {
			amount,
			subId
		}
	})
}

export function takeBackSubAccountBalance (payment, subId) {
	return request({
		url: '/api/merchant/business/sub/recoverPayment',
		method: 'post',
		data: {
			payment,
			subId
		}
	})
}

export function freezeSubAcc (enable, subId) {
	return request({
		url: '/api/merchant/business/sub/freeze',
		method: 'post',
		data: {
			enable,
			subId
		}
	})
}

export function updateSubAcc (type, noticeBalance, title, priceSetting, subId) {
	return request({
		url: '/api/merchant/business/sub/update',
		method: 'post',
		data: {
			type,
			noticeBalance,
			title,
			priceSetting,
			subId
		}
	})
}

export function getSubReqStat (subId, startTime, endTime, categoryName) {
	return request({
		url: '/api/stat/record/sub/req-stat?subId=' + subId + '&startTime=' + startTime + '&endTime=' + endTime + '&categoryName=' + categoryName,
		method: 'get'
	})
}

export function getSubCostStat (subId) {
	return request({
		url: '/api/stat/record/sub/cost-stat?subId=' + subId,
		method: 'get'
	})
}

export function authenticationPersonal (query) {
	return request({
		url: '/api/merchant/business/auth/personal',
		method: 'post',
		data: query
	})
}

export function authenticationCompany (query) {
	return request({
		url: '/api/merchant/business/real-name-authentication',
		method: 'post',
		data: query
	})
}



// WEBPACK FOOTER //
// ./src/services/user.js